<ul class="kt-sticky-toolbar {{expanded ? 'expanded': ''}}">
  <li class="support" (click)="expand()"> Support </li>
  <hr class="vertical-line">
  <span class="position-absolute expanded-section ml-2">
    <a href="javascript:"> <i class="fas fa-comment"></i>&nbsp; Live Chat</a>
    <a href="javascript:"> <i class="fas fa-envelope"></i>&nbsp; Message </a>
    <a href="javascript:"> <i class="fas fa-question-circle"></i>&nbsp; Help </a>
  </span>

</ul>
